// extracted by mini-css-extract-plugin
module.exports = {"header":"header_2Ey8b"};